// 3_pages/product_supporting_bottom.js
// On product pages, inserts the Natios charity-support block after the manufacturer
// description.

export function init() {
	if (!document.body.classList.contains("type-product")) return;

	natiosSupportingBottom();
}

function natiosSupportingBottom() {
	const natiosLargeBrandBlock = document.createElement("div");
	natiosLargeBrandBlock.className = "natios-support-wrapper";
	natiosLargeBrandBlock.innerHTML =
		'<div class="natios-support-icon"><img src="https://cdn.myshoptet.com/usr/www.natima.cz/user/documents/upload/NatiosDarujeFNO_2.svg" alt="Natios Charity" width="174" height="174"></div><div class="natios-support-wrapper-content"><div class="natios-support-wrapper-content-title">' +
		window.NAT.translations("natiosSupportHeaderBottom") +
		" </div><p>" +
		window.NAT.translations("natiosSupportTextBottom") +
		"</p><p>" +
		window.NAT.translations("natiosSupportTotalAmount") +
		'</p><p><a href="' +
		window.NAT.translations("natiosSupportPageUrl") +
		'">' +
		window.NAT.translations("moreAboutSupport") +
		"</a></p></div>";

	const manufacturerDescription = document.querySelector("#manufacturerDescription");

	if (manufacturerDescription) {
		manufacturerDescription.after(natiosLargeBrandBlock);
	}
}
